import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Testbook from "../../assets/login/testbookimg.png";
import { IoClose } from "react-icons/io5";
import Login from "../../assets/login/loginlogo.svg";
import { BiEdit } from "react-icons/bi";
import { TbDeviceMobile } from "react-icons/tb";
import { MdEmail } from "react-icons/md";
// import StudentLogin from "./StudentLogin";
import { axiosRequest } from "../../_config/apiClient";
import StudentLogin from "./StudentLogin";

export default function OTP({ isOtpOpen, onOtpClose, loginMethod, identifier, onEdit }) {
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [captchaValue, setCaptchaValue] = useState(null);
    const [showLogin, setShowLogin] = useState(false);

    if (!isOtpOpen) return null;

    const handleVerifyOtp = async () => {
        if (loading) return;
        setError("");

        if (otp.length !== 6) {
            setError("Please enter valid 6 digit OTP");
            return;
        }

        try {
            setLoading(true);
            let token = sessionStorage.getItem("user");
            const payload = { otp, token }

            const res = await axiosRequest("post", "/user/verifyOtp", payload);

            if (!res?.error) {
                if (res?.data?.token) {
                    localStorage.setItem("user", res.data.token);
                }
                setShowLogin(true);
            } else {
                setError(res?.data?.message || "Invalid OTP, please try again.");
            }
        } catch (err) {
            setError(err?.response?.data?.message || "OTP verification failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[999] px-4">
            <div className="w-full max-w-[1200px] py-6 px-4 sm:px-8 md:px-20 mx-auto rounded-[10px] bg-white relative">
                <button onClick={onOtpClose} className="absolute top-4 w-[24px] h-[24px] flex items-center right-4 justify-center bg-white rounded-full p-1 border border-[#333333]">
                    <IoClose className="text-[#333333] text-[20px]" />
                </button>

                <div className="bg-white h-[600px] overflow-y-auto w-full mx-auto rounded-2xl max-w-[1100px] grid grid-cols-1 lg:grid-cols-2 items-center">
                    <div className="flex-1 p-0 md:pr-18 lg:pr-30 pl-0 md:pl-2">
                        <img src={Login} alt="BaapBola Logo" />

                        <div className="mt-10">
                            <h2 className="text-[23px] md:text-[28px] font-[600] text-[#333333] tracking-tight mb-2">
                                Verify OTP
                            </h2>

                            <div className="flex items-center text-[#666] mb-6 gap-2">
                                {loginMethod === "email" ? <MdEmail /> : <TbDeviceMobile />}
                                <span className="text-[16px] font-[500] text-[#33333399]">{identifier}</span>
                                <button onClick={onEdit} className="ml-auto"><BiEdit className="text-[22px]" /></button>
                            </div>

                            <p className="text-[16px] font-[500] text-[#333333] mb-3 tracking-tight">
                                OTP will be sent to you on above {loginMethod === "email" ? "email" : "number"}
                            </p>

                            <div className={`border-[2px] ${error ? 'border-red-500' : 'border-[#33333399]'} rounded px-3 py-2 flex items-center gap-2 mb-1`}>
                                <span className="font-[600] border px-2">OTP</span>
                                <input
                                    type="text"
                                    maxLength="6"
                                    value={otp}
                                    onChange={(e) => {
                                        setOtp(e.target.value.replace(/\D/g, ""));
                                        if (error) setError("");
                                    }}
                                    className="flex-1 outline-none"
                                    placeholder="Enter OTP"
                                />
                            </div>

                            <div className="h-5 mb-3">
                                {error && (
                                    <p className="text-red-500 text-[13px] font-[500] animate-pulse">
                                        {error}
                                    </p>
                                )}
                            </div>

                            <button className="text-[#4096F6] text-[15px] font-[500] tracking-tight mb-4 hover:underline">
                                Resend OTP
                            </button>

                            <div className="mb-4 w-full overflow-hidden">
                                <ReCAPTCHA
                                    sitekey="YOUR_SITE_KEY_HERE"
                                    onChange={(value) => setCaptchaValue(value)}
                                />
                            </div>

                            <button
                                onClick={handleVerifyOtp}
                                disabled={loading}
                                className={`w-full ${loading ? 'bg-gray-400' : 'bg-[#4096F6] hover:bg-blue-600'} text-white font-semibold py-3 tracking-tight rounded-[8px] shadow-md transition-all mt-2`}
                            >
                                {loading ? "Verifying..." : "Verify OTP"}
                            </button>
                        </div>

                        <p className="mt-8 text-[18px] font-[500] tracking-tight text-[#333333] mt-10">
                            Already have an account?{" "}
                            <button className="text-[#4096F6] font-[500] hover:underline">Signup</button>
                        </p>
                    </div>

                    <div className="flex-1 hidden lg:flex items-center justify-center">
                        <img src={Testbook} alt="Banner" className="w-full h-full object-cover" />
                    </div>
                </div>
            </div>
            {showLogin && <StudentLogin
                isOpen={showLogin}
                onClose={() => setShowLogin(false)}
                identifier={identifier}
                loginMethod={loginMethod}
            />}
        </div>
    );
}